(() => {
  const init = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const brands = root.querySelector('[data-featured-brands]');
    const brandsToggle = brands?.querySelector('[data-brands-toggle]');
    if (brandsToggle) {
      const grid = brands.querySelector('.brand-grid');
      const links = Array.from(grid.children);
      const allBrands = brands.querySelector('[data-brands-all]');
      const mobile = window.matchMedia('(max-width: 600px)');
      const syncBrands = () => {
        const expanded = brandsToggle.getAttribute('aria-expanded') === 'true';
        links.forEach((link, index) => { link.inert = mobile.matches && !expanded && index >= 8; });
        if (mobile.matches) {
          const last = links[Math.min(8, links.length) - 1];
          const height = expanded ? grid.scrollHeight : (last ? last.offsetTop + last.offsetHeight : 0);
          grid.style.maxHeight = `${height}px`;
        } else {
          grid.style.maxHeight = '';
        }
        brandsToggle.textContent = expanded ? 'ー　　閉じる' : '＋　　もっと見る';
        if (allBrands) allBrands.hidden = !mobile.matches || !expanded;
      };
      brands.classList.add('is-enhanced');
      syncBrands();
      brandsToggle.addEventListener('click', () => {
        const closing = brandsToggle.getAttribute('aria-expanded') === 'true';
        brandsToggle.setAttribute('aria-expanded', String(!closing));
        syncBrands();
        if (closing && mobile.matches) {
          const title = brands.querySelector('h2');
          const header = document.querySelector('.be-search-top .site-header .header-main');
          if (title) window.scrollTo({
            top: Math.max(0, window.scrollY + title.getBoundingClientRect().top - (header?.getBoundingClientRect().height || 0) - 12),
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          });
        }
      });
      mobile.addEventListener('change', syncBrands);
      let previousWidth = grid.clientWidth;
      new ResizeObserver(() => {
        if (grid.clientWidth === previousWidth) return;
        previousWidth = grid.clientWidth;
        syncBrands();
      }).observe(grid);
      brands.querySelectorAll('[data-brand-missing]').forEach((item) => {
        console.warn('注目ブランド: 未設定のブランドデータ', item.dataset.brandUrl, item.dataset.brandMissing);
      });
    }

    const preferences = root.querySelector('[data-preference-search]');
    const preferenceToggle = preferences?.querySelector('[data-preference-toggle]');
    if (preferenceToggle) {
      const mobile = window.matchMedia('(max-width: 600px)');
      const syncPreferences = () => {
        const expanded = preferenceToggle.getAttribute('aria-expanded') === 'true';
        preferences.classList.toggle('is-expanded', expanded);
        preferences.querySelectorAll('[data-preference-extra]').forEach((panel) => {
          panel.inert = mobile.matches && !expanded;
        });
        preferenceToggle.textContent = expanded ? 'ー　　閉じる' : '＋　　もっと見る';
      };
      preferences.classList.add('is-enhanced');
      preferenceToggle.addEventListener('click', () => {
        const closing = preferenceToggle.getAttribute('aria-expanded') === 'true';
        preferenceToggle.setAttribute('aria-expanded', String(!closing));
        syncPreferences();
        if (closing && mobile.matches) {
          const title = preferences.querySelector('#preference-title');
          const header = document.querySelector('.be-search-top .site-header .header-main');
          if (title) window.scrollTo({
            top: Math.max(0, window.scrollY + title.getBoundingClientRect().top - (header?.getBoundingClientRect().height || 0) - 12),
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          });
        }
      });
      mobile.addEventListener('change', syncPreferences);
      syncPreferences();
    }

    // Wishlist Hero renders and owns the real add/remove buttons. Dynamic history cards
    // use the app's documented custom-element event after insertion.
    const initializeWishlist = (container) => {
      container.querySelectorAll('.be-wishlist').forEach((element) => {
        if (element.querySelector('button')) return;
        document.dispatchEvent(new CustomEvent('wishlist-hero-add-to-custom-element', { detail: element }));
      });
    };

    const reasons = root.querySelector('[data-reasons-parallax]');
    const reasonsMedia = root.querySelector('[data-reasons-parallax-media]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobileReasons = window.matchMedia('(max-width: 600px)');
    let reasonsVisible = false;
    let reasonsTicking = false;
    const updateReasonsParallax = () => {
      reasonsTicking = false;
      if (!reasons || !reasonsMedia || !reasonsVisible || reducedMotion.matches) return;
      const rect = reasons.getBoundingClientRect();
      const viewportCenter = window.innerHeight / 2;
      const sectionCenter = rect.top + rect.height / 2;
      const progress = Math.max(-1, Math.min(1, (viewportCenter - sectionCenter) / ((window.innerHeight + rect.height) / 2)));
      const maxOffset = mobileReasons.matches ? 14 : 24;
      reasonsMedia.style.setProperty('--reasons-parallax-y', `${(progress * maxOffset).toFixed(2)}px`);
    };
    const queueReasonsParallax = () => {
      if (!reasonsVisible || reducedMotion.matches || reasonsTicking) return;
      reasonsTicking = true;
      window.requestAnimationFrame(updateReasonsParallax);
    };
    if (reasons && reasonsMedia) {
      const reasonsObserver = new IntersectionObserver(([entry]) => {
        reasonsVisible = entry.isIntersecting;
        if (reasonsVisible) queueReasonsParallax();
      }, { rootMargin: '15% 0px' });
      reasonsObserver.observe(reasons);
      window.addEventListener('scroll', queueReasonsParallax, { passive: true });
      window.addEventListener('resize', queueReasonsParallax, { passive: true });
      mobileReasons.addEventListener?.('change', queueReasonsParallax);
      reducedMotion.addEventListener?.('change', (event) => {
        if (event.matches) {
          reasonsMedia.style.removeProperty('--reasons-parallax-y');
          return;
        }
        queueReasonsParallax();
      });
    }

    const hero = root.querySelector('[data-hero]');
    const track = root.querySelector('[data-hero-track]');
    const slides = [...root.querySelectorAll('[data-hero-slide]')];
    const dots = [...root.querySelectorAll('[data-hero-dot]')];
    const count = dots.length;
    let position = count;
    let active = 0;
    let timer;
    let pointerStart = null;
    let heroPointerId = null;
    let suppressHeroClick = false;
    let heroDragFrame = null;
    let heroDragOffset = 0;
    let heroDragOrigin = 0;
    const mobileHero = window.matchMedia('(max-width: 600px)');
    const queueHeroDrag = (offset) => {
      heroDragOffset = offset;
      if (heroDragFrame !== null) return;
      heroDragFrame = window.requestAnimationFrame(() => {
        heroDragFrame = null;
        track?.style.setProperty('--hero-drag-offset', `${heroDragOffset}px`);
      });
    };
    const resetHeroDrag = () => {
      if (heroDragFrame !== null) window.cancelAnimationFrame(heroDragFrame);
      heroDragFrame = null;
      heroDragOffset = 0;
      track?.style.setProperty('--hero-drag-offset', '0px');
    };
    const paintHero = (animate = true) => {
      if (!track) return;
      track.classList.toggle('is-moving', animate);
      track.style.transform = `translate3d(calc(var(--hero-center-offset) - ${position} * var(--hero-slide-width) + var(--hero-drag-offset, 0px)),0,0)`;
      slides.forEach((slide, index) => {
        slide.classList.toggle('is-previous', index === position - 1);
        slide.classList.toggle('is-view', index === position);
        slide.classList.toggle('is-next', index === position + 1);
      });
      dots.forEach((dot, index) => dot.classList.toggle('active', index === active));
    };
    const normalizeHeroPosition = () => {
      while (position >= count * 2) position -= count;
      while (position < count) position += count;
    };
    const moveHero = (delta) => {
      normalizeHeroPosition();
      position += delta;
      active = (active + delta + count) % count;
      paintHero(true);
    };
    const restart = () => {
      window.clearInterval(timer);
      timer = window.setInterval(() => moveHero(1), 6000);
    };
    track?.addEventListener('transitionend', () => {
      if (position >= count * 2 || position < count) {
        normalizeHeroPosition();
        paintHero(false);
      }
    });
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState !== 'visible') return;
      normalizeHeroPosition();
      paintHero(false);
      restart();
    });
    hero?.addEventListener('pointerdown', (event) => {
      if (pointerStart !== null || (event.button !== undefined && event.button !== 0)) return;
      heroDragOrigin = 0;
      if (mobileHero.matches && track) {
        // Preserve the rendered position when a finger interrupts autoplay.
        const renderedX = new DOMMatrixReadOnly(getComputedStyle(track).transform).m41;
        resetHeroDrag();
        paintHero(false);
        const targetX = new DOMMatrixReadOnly(getComputedStyle(track).transform).m41;
        heroDragOrigin = renderedX - targetX;
        track.style.setProperty('--hero-drag-offset', `${heroDragOrigin}px`);
      }
      pointerStart = { x: event.clientX, y: event.clientY, axis: null, lastX: event.clientX, lastTime: event.timeStamp, velocityX: 0 };
      heroPointerId = event.pointerId;
      suppressHeroClick = false;
      window.clearInterval(timer);
    });
    hero?.addEventListener('pointermove', (event) => {
      if (pointerStart === null) return;
      const deltaX = event.clientX - pointerStart.x;
      const deltaY = event.clientY - pointerStart.y;
      const elapsed = Math.max(1, event.timeStamp - pointerStart.lastTime);
      const instantVelocity = (event.clientX - pointerStart.lastX) / elapsed;
      pointerStart.velocityX = pointerStart.velocityX * .65 + instantVelocity * .35;
      pointerStart.lastX = event.clientX;
      pointerStart.lastTime = event.timeStamp;
      if (!pointerStart.axis && Math.max(Math.abs(deltaX), Math.abs(deltaY)) > 5) {
        pointerStart.axis = Math.abs(deltaX) > Math.abs(deltaY) * 1.1 ? 'x' : 'y';
      }
      if (pointerStart.axis === 'x') {
        suppressHeroClick = true;
        hero.setPointerCapture?.(event.pointerId);
        if (window.matchMedia('(max-width: 600px), (pointer: coarse)').matches) {
          track?.classList.remove('is-moving');
          queueHeroDrag(deltaX + heroDragOrigin);
        }
      }
    });
    hero?.addEventListener('pointerup', (event) => {
      if (pointerStart === null) return;
      const delta = event.clientX - pointerStart.x;
      const wasHorizontal = pointerStart.axis === 'x';
      const projectedDelta = delta + pointerStart.velocityX * 160;
      pointerStart = null;
      suppressHeroClick = suppressHeroClick || wasHorizontal;
      if (mobileHero.matches && track) {
        // Commit the last drag frame before enabling the settling transition.
        if (heroDragFrame !== null) window.cancelAnimationFrame(heroDragFrame);
        heroDragFrame = null;
        track.style.setProperty('--hero-drag-offset', `${wasHorizontal ? delta + heroDragOrigin : heroDragOrigin}px`);
        void track.offsetWidth;
        track.classList.add('is-moving');
      }
      resetHeroDrag();
      if (wasHorizontal && Math.abs(projectedDelta) > hero.clientWidth * .06) moveHero(projectedDelta < 0 ? 1 : -1);
      else paintHero(true);
      if (heroPointerId !== null && hero.hasPointerCapture?.(heroPointerId)) hero.releasePointerCapture(heroPointerId);
      heroPointerId = null;
      restart();
    });
    hero?.addEventListener('pointercancel', () => {
      pointerStart = null;
      suppressHeroClick = true;
      resetHeroDrag();
      paintHero(true);
      heroPointerId = null;
      restart();
    });
    slides.forEach((slide, index) => slide.addEventListener('click', (event) => {
      if (suppressHeroClick) {
        event.preventDefault();
        suppressHeroClick = false;
      } else if (index === position - 1) {
        event.preventDefault();
        moveHero(-1);
      } else if (index === position + 1) {
        event.preventDefault();
        moveHero(1);
      }
      restart();
    }));
    dots.forEach((dot) => dot.addEventListener('click', () => {
      const next = Number(dot.dataset.heroDot);
      let delta = next - active;
      if (delta > count / 2) delta -= count;
      if (delta < -count / 2) delta += count;
      if (delta) moveHero(delta);
      restart();
    }));
    paintHero(false);
    restart();



    root.querySelectorAll('[data-product-section]').forEach((section) => {
      const slider = section.querySelector('[data-product-slider]');
      section.querySelectorAll('[data-slide]').forEach((button) => button.addEventListener('click', () => {
        if (!slider) return;
        const cards = Array.from(slider.querySelectorAll('.product-card:not([hidden])'));
        if (cards.length < 2) return;
        // Measure the rendered pitch: columnGap can be a percentage or calc(), not pixels.
        const step = Math.abs(cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left);
        if (!Number.isFinite(step) || step <= 0) return;
        slider.scrollBy({ left: Number(button.dataset.slide) * step, behavior: 'smooth' });
      }));
      section.querySelectorAll('[role="tab"]').forEach((tab) => tab.addEventListener('click', async () => {
        section.querySelectorAll('[role="tab"]').forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
        const group = tab.dataset.productGroup;
        if (group === 'staff_recent' && slider) {
          await window.BeStaffRecommendations?.load(section, slider);
          initializeWishlist(slider);
        }
        // A slow recommendation response must not override a newer tab selection.
        if (tab.getAttribute('aria-selected') !== 'true') return;
        slider?.querySelectorAll('.product-card').forEach((card) => { card.hidden = card.dataset.productGroup !== group; });
        if (slider) {
          slider.scrollLeft = 0;
          slider.dispatchEvent(new CustomEvent('be-search:products-changed', {
            detail: { group, count: slider.querySelectorAll('.product-card:not([hidden])').length },
          }));
        }
      }));
      if (slider) {
        let dragState = null;
        let suppressClick = false;
        const dragThreshold = 8;
        slider.addEventListener('pointerdown', (event) => {
          if (event.pointerType && event.pointerType !== 'mouse') return;
          if (event.target.closest('button')) return;
          suppressClick = false;
          dragState = { x: event.clientX, scrollLeft: slider.scrollLeft, moved: false, pointerId: event.pointerId };
          slider.classList.add('is-dragging');
        });
        slider.addEventListener('pointermove', (event) => {
          if (!dragState) return;
          const distance = event.clientX - dragState.x;
          if (Math.abs(distance) >= dragThreshold && !dragState.moved) {
            dragState.moved = true;
            slider.setPointerCapture(event.pointerId);
          }
          slider.scrollLeft = dragState.scrollLeft - distance;
        });
        const endDrag = (event) => {
          if (!dragState) return;
          suppressClick = dragState.moved;
          if (suppressClick) window.setTimeout(() => { suppressClick = false; }, 0);
          dragState = null;
          if (slider.hasPointerCapture?.(event.pointerId)) slider.releasePointerCapture(event.pointerId);
          slider.classList.remove('is-dragging');
        };
        slider.addEventListener('pointerup', endDrag);
        slider.addEventListener('pointercancel', endDrag);
        slider.addEventListener('click', (event) => {
          if (!suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
          suppressClick = false;
        }, true);
        slider.addEventListener('wheel', (event) => {
          if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
          event.preventDefault();
          slider.scrollBy({ left: event.deltaX, behavior: 'auto' });
        }, { passive: false });
      }
    });

    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    }), { threshold: .12, rootMargin: '0px 0px -5% 0px' });
    root.querySelectorAll('.quick-grid a,.section h2,.category-grid a,.brand-grid a,.concern-grid a,.product-card,.reasons-wrap,.two-banners a').forEach((node, index) => {
      node.classList.add('motion-reveal');
      node.style.setProperty('--motion-delay', `${(index % 5) * 70}ms`);
      observer.observe(node);
    });
  };
  const initAll = () => document.querySelectorAll('[data-be-search-top]').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initAll) : initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
